import React, { Component } from "react";
import "./ECommerce.module.scss";
import MainPicture from "../Section/MainPicture";
import image from './img/e-commerce.png';
import sylius from './img/sylius.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/paint-roller.png";
import picturequality from "./img/3D.png";
import LeftPicture from "../Section/LeftPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/jewel.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";

class ECommerce extends Component {
  render() {
    let alt = "E-Commerce";
    let description = ["L'E-Commerce B2B ou B2C est un canal de vente exceptionnel qu'il faut traiter comme tel. C'est pourquoi nous proposons la mise en place de ", <strong>solutions de vente en ligne innovantes</strong>, " et sur-mesure pour optimiser ce canal de vente comme il se doit !"];


    let smalltitle = "Réunissons nos expertises";
    let titlemethodo = "Inventons ensemble votre plateforme de vente !";
    let descriptionmethodo = [
        "Nous vous accompagnons pour imaginer une solution qui collera parfaitement à votre identité et vos produits tout en étant optimisé pour la vente en ligne.", 
        ];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "sublimons vos produits";
    let titleevol = "Mettre en avant vos produits d'exception !";
    let descriptionevol = ["nous réalisons des sites E-Commerce qui équilibrent l'exposition de vos produits telles des ", <strong>oeuvres d'art</strong>, " avec la force du ", <strong>E-Marketing</strong>, ". ", <br/>, <br />,
                    "Vous souhaitez vendre en ligne des produits inédits ? des produits complexes ? nous vous accompagnons dans toute votre stratégie en ligne !"];

    let altevol = "Intégration du portail dans votre système d'information";

    let smalltitleCheck = "Tous les supports, partout, tout le temps !" ;
    let titleCheck = "L'innovation technologique au service du E-Commerce";
    let subtitle1Check = "Vos produits en 3D";
    let text1Check = ["Nous réalisons des configurateurs en ligne en vrai 3D compatible PC, Tablette, Smartphone de vos produits." ];
    let subtitle2Check = "La vente sur tous les supports";
    let text2Check = "Nos applications E-Commerce sont responsives et donc compatibles avec tous les supports comme le téléphone mobile, la tablette tactile ou encore le PC.";
    let subtitle3Check = "Un configurateur en ligne";
    let text3Check = ["Vous avez des produits complexes ? Des milliers de variantes possibles ? Vous souhaitez pouvoir générer de nouveaux sites E-Commerce à la volée ? " ,<a href="/contact" title="Nous contacter">N'hésitez pas à nous contacter !</a>];
    let pictureCheck = picturequality;
    let altCheck = "Le E-Commerce d'excellence";

    let description3 = ["Chez Integral Service nous développons des expériences et solutions", <strong>E-Commerce</strong>, " sur-mesure à l'aide de technologies flexibles, innovantes, pérennes, sécurisées et évolutives ! C'est pourquoi nos sites sont développés avec ", <a href="/expert-symfony" title="En savoir plus sur Symfony">Symfony</a>, " et Sylius. Ces technologies nous permettent de créer des solutions clefs en main, connectées, compatibles avec votre système d'information et puissantes."];
    let altSylius = "Logo officiel de Sylius";
    
    return (
      <div className="generic-services">
        <MainPicture title="Un canal de vente exceptionnel" description={description} picture={image} alt={alt} />
        <LeftPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />
       <MainPicture title="Les meilleures technologies pour vos clients" description={description3} picture={sylius} alt={altSylius} />
      </div>
    );
  }
}

export default ECommerce;



// WEBPACK FOOTER //
// ./src/components/Page/ECommerce.jsx